import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Planilla/planilla';
import EdicionBonos from './bonosempledo';

const mstp = state => {
    return {...state.planilla , permisos: state.login.me.permisos}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(EdicionBonos)
